import { put, call, takeLatest } from 'redux-saga/effects';
import {fetchChannelCategoriesRequest} from '../api/Api';
import * as types from '../constants/actionTypes';

// Responsible for searching media library, making calls to the API
// and instructing the redux-saga middle ware on the next line of action,
// for success or failure operation.
export default function* watchChannelCategoriesListener() {
  yield takeLatest(types.FETCH_CHANNEL_CATEGORIES_REQUEST, fetchChannelCategoriesRequestSaga);
}

export function* fetchChannelCategoriesRequestSaga({ payload }) {
  // console.log('saga')
  try {
    const res = yield call(fetchChannelCategoriesRequest, payload);
    yield [
      put({ type: types.FETCH_CHANNEL_CATEGORIES_SUCCESS, res })
    ];
  } catch (error) {
    yield put({ type: types.FETCH_CHANNEL_CATEGORIES_FAILED, error });
  }
}


// WEBPACK FOOTER //
// ./src/sagas/channelsSaga.js